import {
  adColumnPreviewStyle,
  locationCellStatusStyle,
  underlineLinkStyle,
  deliveryColumnStyle,
  labelsCellItemStyle,
  dateCellStyles,
} from '@bingads-webui-campaign-react/common-styles';

import { getSharedColumnsStyles } from './shared';

export default (components, { palette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  ...getSharedColumnsStyles(),
  ...dateCellStyles({ palette }),

  '&:first-child, &:nth-child(2), &:nth-child(3)': {
    borderLeft: 'none',
  },

  '&:first-child, &:nth-child(2), &:last-child': {
    borderRight: 'none',
  },

  // By default, the 3rd column is the primary column, use 14px.
  // If not, it will be overridden via getColumnSolidBorderStyle().
  // Unfortunately, side effect on aggregate(d)-row will need other
  // way to fix with usage of '12px!important'.
  '&:nth-child(3)': {
    fontSize: '14px',
  },

  '& .quality-score-tooltip ': {
    cursor: 'pointer',

    '& + .popover': {
      maxWidth: '350px',
      width: '350px',

      '& .qs-Poor': {
        color: '#A80000',
      },
      '& .qs-Good': {
        color: '#107C10',
      },
      '& .qs-Values': {
        '& td:first-child': {
          paddingLeft: 0,
        },
      },

    },
  },

  '&.grid-column-Status': {
    '& .grid-edit-icon': {
      display: 'none',
    },

    '& .iconba': {
      '&::before': {
        fontSize: '12px',
        lineHeight: '12px',
      },
    },

    '& .iconba-RadioBullet': {
      color: '#107C10',
    },

    '& .iconba-PauseListView12': {
      color: '#323130',
    },
    '& .statusDraft_icon': {
      verticalAlign: 'text-bottom',
    },
    '& .statusEnabled_icon': {
      verticalAlign: 'text-bottom',
    },
    '& .statusPaused_icon': {
      verticalAlign: 'text-bottom',
    },
    '& .experiment-paused-icon': {
      verticalAlign: 'text-bottom',
    },
    '& .experiment-active-icon': {
      verticalAlign: 'text-bottom',
    },
    '& .statuschangehover:before': {
      fontSize: '11px',
      fontStyle: 'normal',
      fontFamily: 'MsAds MDL2 Assets',
      fontWeight: 'normal',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      float: 'right',
      content: '"\\E70D"',
      color: palette.themeDark,
      marginLeft: '5px',
    },
  },


  // eslint-disable-next-line no-multi-str
  '&.grid-column-AdGroup, \
  &.grid-column-Campaign, \
  &.audiences-column-Campaign, \
  &.col-AdGroupName, \
  &.col-CampaignName': {
    '& a': {
      lineHeight: '16px',
    },
    ...underlineLinkStyle({ palette, elementLocator: 'a.experiment-name' }),
  },

  '&.grid-column-Bid, &.grid-column-CpmBid, &.grid-column-CpvBid, &.grid-column-SearchBid': {
    '& .bidlandscape-column': {
      display: 'inline-block',
      verticalAlign: 'middle',
    },
    '& .grid-edit-icon': {
      verticalAlign: 'middle',
    },
    '& .iconba-Financial:hover': {
      cursor: 'pointer',
    },
  },

  // eslint-disable-next-line no-multi-str
  '&.grid-column-Bid, \
   &.grid-column-CpmBid, \
   &.grid-column-CpvBid, \
   &.grid-column-SearchBid, \
   &.grid-column-Budget, \
   &.grid-column-BidStrategyType, \
   &.grid-column-Delivery, \
   &.grid-column-biddingStrategyTargetCpa, \
   &.grid-column-biddingStrategyTargetRoas': {
    '& .iconba-Financial': {
      color: palette.themePrimary,
    },
    '& .iconba-Financial.disabled': {
      color: palette.neutralTertiary,
    },
  },

  '& .labels-cell-container': {
    ...labelsCellItemStyle(),
  },

  // eslint-disable-next-line no-multi-str
  '&.grid-column-Campaign, \
  &.grid-column-AdGroup, \
  &.grid-column-Name, \
  &.grid-column-TrackingTemplate, \
  &.grid-column-CustomParameters, \
  &.grid-column-UrlCustomParameters, \
  &.grid-column-FinalUrlSuffix, \
  &.col-CampaignName, \
  &.grid-column-Keyword, \
  &.grid-column-SearchTerm, \
  &.grid-column-Param1, \
  &.grid-column-Param2, \
  &.grid-column-Param3, \
  &.grid-column-NegativeKeyword, \
  &.grid-column-LandingPage, \
  &.grid-column-Budget, \
  &.grid-column-FinalUrlSuffix, \
  &.cell-changes, \
  &.col-AdGroupName, \
  &.col-AdExtension, \
  &.col-AdExtensionId, \
  &.grid-column-Description, \
  &.grid-column-Entity, \
  &.grid-column-ChangeTo, \
  &.grid-column-OldValue, \
  &.grid-column-NewName, \
  &.automated-rules__rule-name, \
  &.grid-column-FeedName, \
  &.dsa-target-col, \
  &.grid-column-Asset, \
  &.grid-column-AssetType, \
  &.grid-column-PinnedField, \
  &.grid-column-When, \
  &.grid-column-BidStrategyName, \
  &.grid-column-PerformanceTargetName': {
    wordWrap: 'break-word',
    wordBreak: 'break-word',

    // fix ie flex item wordWrap issue in ui-next
    '& .grid-editable-cell-container': {
      // eslint-disable-next-line no-multi-str
      '& > .scope-navigator, \
      & > .grid-cell-text, \
      & > .final-url, \
      & > .campaign-column-name': {
        display: 'inline',
        width: '90%',
      },
    },
  },

  '&.grid-column-CustomParameters': {
    '& .parameters': {
      display: 'inline-block',
      width: '90%', // without setting boundary, break-word will not work on IE
    },
  },

  '&.text-left .grid-editable-cell-container': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },

  '&.text-right .grid-editable-cell-container': {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },

  '.status-image': {
    clear: 'none',
    float: 'right',
  },

  '&.grid-column-Delivery': {
    ...deliveryColumnStyle(),
  },

  '&.grid-column-AssetStatus': {
    '& .statusicondisplay': {
      cursor: 'default',
    },
  },

  '&.grid-column-AdPreview': {
    ...adColumnPreviewStyle(),
  },

  '&.grid-column-Location': {
    ...locationCellStatusStyle({ iconFontFamily }),
  },
  '&[data-column="ConversionsCredit"]': {
    '& .status-warning': {
      color: '#D83B01',
      borderBottom: '1px dashed #0078D4',
      cursor: 'pointer',
    },
  },
});
